import { createSlice } from "@reduxjs/toolkit";

import adapter from "../adapter";

const addClient = ({ client, state }) => {
  const { id } = client;
  const existingJob = state.entities[id];
  if (existingJob === undefined || client.updatedAt >= existingJob.updatedAt) {
    adapter.upsertOne(state, client);
  }
};

const initialState = {
  ...adapter.getInitialState(),
};

const slice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    setClients: (state, action) => {
      const { clients } = action.payload;
      clients.forEach((client) => {
        addClient({ client, state });
      });
    },
    setClient: (state, action) => {
      const { client } = action.payload;
      addClient({ client, state });
    },
  },
});

const { actions, reducer } = slice;

export const { setClients, setClient } = actions;

export default reducer;
